<script>
    import { onMount, createEventDispatcher } from 'svelte'
    import { fly } from 'svelte/transition'
    import { navigateTo } from 'yrv'
    import axios from 'axios'
    
    import FadeinFX from '../../components/FX/FadeinFx.svelte'
    import AdminLayout from '../../layouts/AdminLayout.svelte'
    import ClientItem from './ClientItem.svelte'
    import Sidepanel from '../../components/Sidepanel/Sidepanel.svelte'
    import SideContent from './ClientDetailsSideContent.svelte'
    import SmartField from '../../components/SmartField/SmartField.svelte'
    import ClientAddressList from './ClientAddressList.svelte'
    import userStore from '../../stores/user'

    import { height as windowHeight } from '../../stores/bounds'

    export let id
    export let background;


    const dispatch = createEventDispatcher ();
    
    let screenReady     = false,
        client          = null,
        model           = null
        

    const fetchModel = () => {
        dispatch ('app-event', { id: 'background', value: true });
        axios.request ({
            method: 'get',
            url: '/api/clients/view/' + id
        }).then (results => {
            client = results.data.client
            dispatch ('app-event', { id: 'background', value: false });
            screenReady = true
        })
    }

    const onSave = () => {
        dispatch ('app-event', { id: 'background', value: true });
        client.address = client.address.filter (it => it.name !== '')
        console.log ('client', client.address)
        axios.request ({
            method: 'post',
            url: '/api/clients/save',
            data: { ...client }
        }).then (result => {
            dispatch ('app-event', { id: 'background', value: false });
            dispatch ('app-event', { id: 'confirm', value: true });
        })
    }

    const onAddressChange = event => {
        // console.log ('address change', event.detail)
        client.address = event.detail
        client = client;
    }

    $: if (id) {
        fetchModel ()
    }

    $: validForm = client ? client.name.trim() !== '' : false
</script>


<Sidepanel>
    <SideContent {client} />
</Sidepanel>
<AdminLayout classes="sidepanel">
    <div class="ClientDetails">
        {#if screenReady}
            <FadeinFX delay={300} delayOut={0}>
                <div class="heading">{client.name}</div>
                <div class="form">
                    <SmartField type="input" name="client_code" label="Codice Cliente" bind:value={client.client_code} />
                    <SmartField type="input" name="name" label="Nome" bind:value={client.name} />
                    <SmartField type="input" name="social_r" label="Ragione Sociale" bind:value={client.social_r} />
                    <SmartField type="input" name="cf" label="Codice Fiscale" bind:value={client.cf} />
                    <SmartField type="input" name="piva" label="Partita Iva" bind:value={client.piva} />
                    <SmartField type="input" name="r_person" label="Persona di rif." bind:value={client.r_person} />
                    <SmartField type="input" name="phone" label="Telefono" bind:value={client.phone} />
                    <SmartField type="input" name="email" label="Email" bind:value={client.email} />
                    <SmartField type="input" name="info" label="Informazioni" bind:value={client.info} />

                    <ClientAddressList data={client.address} on:change={onAddressChange} />
                </div>
                <div class="ctrls" in:fly={{ y: -60, duration: 300, delay: 300 }}>
                    <button class="btn btn-sm btn-primary" disabled={validForm === false} on:click={onSave}>Salve Modifiche</button>
                </div>
                <!-- <pre>
                    {JSON.stringify (client, null, '   ')}
                </pre> -->
            </FadeinFX>
        {/if}
    </div>
</AdminLayout>


<style>
    .ClientDetails {
        padding: 20px;
    }
    .heading {
        margin-bottom: 20px;
    }
    .ctrls {
        margin-top: 20px;
    }
</style>